import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { IAttachmentSourceOptionLabelService, ISourceOption } from './iattachment-source-option-label.service';

@Injectable({ providedIn: 'root' })
export class InveniasAttachmentSourceOptionLabelService implements IAttachmentSourceOptionLabelService {
  getOptions(optionPaths: string[]): Observable<ISourceOption[]> {
    return of((optionPaths ?? []).map((path) => ({ label: path, toolTip: path, path })));
  }
}
